import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxDnDModule } from '@swimlane/ngx-dnd';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseConfirmDialogModule, FuseMaterialColorPickerModule, FuseWidgetModule } from '@fuse/components';
import { BoardResolve, ScrumboardService } from './scrumboard.service';
import { ScrumboardComponent } from './scrumboard.component';
import { ScrumboardBoardComponent } from './board/board.component';
import { ScrumboardBoardListComponent } from './board/list/list.component';
import { ScrumboardBoardCardComponent } from 'app/main/pages/scrumboard/board/list/card/card.component';
import { ScrumboardBoardEditListNameComponent } from './board/list/edit-list-name/edit-list-name.component';
import { ScrumboardBoardAddCardComponent } from './board/list/add-card/add-card.component';
import { ScrumboardBoardAddListComponent } from './board/add-list/add-list.component';
import { ScrumboardCardDialogComponent } from './board/dialogs/card/card.component';
import { ScrumboardEditBoardNameComponent } from './board/edit-board-name/edit-board-name.component';
import { ScrumboardBoardSettingsSidenavComponent } from './board/sidenavs/settings/settings.component';
import { ScrumboardBoardColorSelectorComponent } from './board/sidenavs/settings/board-color-selector/board-color-selector.component';
import { ScrumboardLabelSelectorComponent } from './board/dialogs/card/label-selector/label-selector.component';
import { AuthGuardService } from '../authentication/auth-guard.service';
import { MatSelectModule, MatRadioModule, MatPaginatorModule, MatAutocompleteModule, MatBadgeModule, MatTableModule, MatCardModule } from '@angular/material';
import { TimeAgoPipe } from 'time-ago-pipe';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgxTimeDurationPickerModule } from 'ngx-time-duration-picker';
import { MatTabsModule } from '@angular/material';
import { SprintComponent } from './board/sprint/sprint.component';
import { AccordionModule } from 'primeng/accordion';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MultiSelectModule, ChartModule, DropdownModule } from 'primeng/primeng';
import { CollapseComponent } from './board/collapse/collapse.component';
import { CollapsePanelComponent } from './board/collapse/collapse-panel/collapse-panel.component';
import { CollapseItemComponent } from './board/collapse/collapse-item/collapse-item.component';
import { WorkItemsComponent } from './board/work-items/work-items.component';
import { TableModule } from 'primeng/table';
import { SprintListComponent } from './board/sprint-list/sprint-list.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ReportsComponent } from './board/reports/reports.component';
import { ExcelService } from './excel.service';
import { SprintDashboardComponent } from './board/sprint-dashboard/sprint-dashboard.component';
import { SprintDashboardModule } from './board/sprint-dashboard/sprint-dashboard.module';
import { SprintScreenshotsComponent } from './board/sprint-screenshots/sprint-screenshots.component';
import { HeaderComponent } from './board/header/header.component';
import { ScrumboardConfirmDialogComponent } from './board/scrumboard-confirm-dialog/scrumboard-confirm-dialog.component';
import { AnalyticsComponent } from './board/analytics/analytics.component';

const routes: Routes = [

    // {
    //     path: 'scrumboard/boards',
    //     component: ScrumboardComponent,
    //     resolve: {
    //         scrumboard: ScrumboardService
    //     },
    //     canActivate: [AuthGuardService]
    // },
    {
        path: 'scrumboard/boards/:boardId/:boardUri',
        component: ScrumboardBoardComponent,
        resolve: {
            board: BoardResolve
        },
        canActivate: [AuthGuardService]
    },
    {
        path: 'scrumboard/board/sprint/:boardId/:boardUri',
        component: SprintComponent,
        resolve: {
            board: BoardResolve
        },
        canActivate: [AuthGuardService]
    },
    {
        path: 'scrumboard/board/analytics/:boardId/:boardUri',
        component: AnalyticsComponent,
        resolve: {
            board: BoardResolve
        },
        canActivate: [AuthGuardService]
    },
    {
        path: 'scrumboard/board/sprint-dashboard/:boardId/:boardUri',
        component: SprintDashboardComponent,
        resolve: {
            board: BoardResolve
        },
        canActivate: [AuthGuardService]
    },
    {
        path: 'scrumboard/board/work-items/:boardId/:boardUri',
        component: WorkItemsComponent,
        resolve: {
            board: BoardResolve
        },
        canActivate: [AuthGuardService]
    },
    {
        path: 'scrumboard/board/sprint-list/:boardId/:boardUri',
        component: SprintListComponent,
        resolve: {
            board: BoardResolve
        },
        canActivate: [AuthGuardService]
    },
    {
        path: 'scrumboard/board/reports/:boardId/:boardUri',
        component: ReportsComponent,
        resolve: {
            board: BoardResolve
        },
        canActivate: [AuthGuardService]
    },
    {
        path: '**',
        redirectTo: 'boards',
        canActivate: [AuthGuardService]
    }
];

@NgModule({
    declarations: [
        ScrumboardComponent,
        ScrumboardBoardComponent,
        ScrumboardBoardListComponent,
        ScrumboardBoardCardComponent,
        ScrumboardBoardEditListNameComponent,
        ScrumboardBoardAddCardComponent,
        ScrumboardBoardAddListComponent,
        ScrumboardCardDialogComponent,
        ScrumboardLabelSelectorComponent,
        ScrumboardEditBoardNameComponent,
        ScrumboardBoardSettingsSidenavComponent,
        ScrumboardBoardColorSelectorComponent,
        TimeAgoPipe,
        SprintComponent,
        CollapseComponent,
        CollapsePanelComponent,
        CollapseItemComponent,
        WorkItemsComponent,
        SprintListComponent,
        ReportsComponent,
        SprintDashboardComponent,
        SprintScreenshotsComponent,
        HeaderComponent,
        ScrumboardConfirmDialogComponent,
        AnalyticsComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        DragDropModule,
        VirtualScrollerModule,
        ScrollingModule,
        MatBadgeModule,
        MatButtonModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressBarModule,
        MatRippleModule,
        MatSidenavModule,
        MatToolbarModule,
        MatTooltipModule,
        MatOptionModule,
        MatSelectModule,
        NgxDnDModule,
        MatRadioModule,
        MatTabsModule,
        MatPaginatorModule,
        AccordionModule,
        FuseSharedModule,
        FuseConfirmDialogModule,
        FuseMaterialColorPickerModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        NgxMaterialTimepickerModule,
        FuseWidgetModule,
        NgxTimeDurationPickerModule,
        TableModule,
        MultiSelectModule,
        MatAutocompleteModule,
        ChartModule,
        NgxChartsModule,
        DropdownModule,
        DropdownModule,
        MatTableModule,
        MatCardModule,
        SprintDashboardModule
    ],
    providers: [
        ScrumboardService,
        BoardResolve,
        ExcelService

    ],
    exports: [
        TimeAgoPipe
    ],

    entryComponents: [ScrumboardCardDialogComponent, ScrumboardConfirmDialogComponent]
})
export class ScrumboardModule { }
